import { ICardProperty } from "@rf-model/card-property.model";
import React, { memo } from "react";
import usePropertyActionsPermissions from "../hooks/usePropertyActionsPermissions";
import MxCardPropertySmall from "@rf-l1/cards/property/MxCardPropertySmall";
import { Box, Grid, styled } from "@mui/material";
import PropertyCheckRefererOption from "./PropertyCheckRefererOption";
import MxListEmptyTemplate from "@rf-l1/page/list/MxlistEmptyTemplate";
import { PropertyListButtonFilters } from "./PropertyListButtonFilters";
import usePropertyListLoading from "../hooks/usePropertyListLoading";
import MxListLoadingTemplate from "@rf-l1/page/list/MxlistLoadingTemplate";
import MxListErrorTemplate from "@rf-l1/page/list/MxlistErrorTemplate";

interface PropertyListCardProps {
  properties: ICardProperty[];
}
const PropertyListCard = memo((props: PropertyListCardProps) => {
  const { getOptions, handleShowDetail } = usePropertyActionsPermissions();
  const { isLoading, isUninitialized, isError } = usePropertyListLoading();

  if (isLoading || isUninitialized) {
    return <MxListLoadingTemplate />;
  }
  if (isError) {
    return <MxListErrorTemplate />;
  }

  if (props.properties.length == 0) {
    return (
      <MxListEmptyTemplate
        variant="with-filters"
        title="¡Sin resultados!"
        description="Actualmente tus filtros están limitando la búsqueda. Ajusta tus filtros para descubrir más propiedades."
        button={<PropertyListButtonFilters />}
      />
    );
  }

  return (
    <Container>
      {props.properties?.map((property, index) => (
        <Grid item xs={12} key={property.id} className="slide-up">
          <MxCardPropertySmall
            itemsMenu={getOptions(property.dirtyState)}
            {...property}
            topLeftComponent={<PropertyCheckRefererOption property={property} />}
            onClick={() => {
              handleShowDetail(Number(property.id));
            }}
          />
        </Grid>
      ))}
    </Container>
  );
});

export default PropertyListCard;

const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
  gap: 16,
  padding: 15
}));
